app.controller('SystemApiNew', function($scope, $http, _$toast, $rootScope, systemApiService, $stateParams, _$privileges, _$editmode) {

    $scope.api = {
        'name': '',
        'login': '',
        'password': '',
        'default_mobile_available': '',
        'notification': []
    };

    $scope.data = {
        'notificications': [],
        "id": $stateParams.id,
        "header": "",
        "editable": true,
        "can_write": _$privileges.write("admin")
    };

    $scope.checkForm = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.save = function(form) {
        var params = angular.copy($scope.api);

        var promise = typeof $scope.data.id != "undefined" ? systemApiService.update($scope.data.id, params) : systemApiService.store(params);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    $rootScope.notification.showAfterRedirect('admin_systemapi', {}, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd ' + (typeof $scope.id != "undefined " ? 'edycji' : 'dodawania') + ' systemu api');
            });

    };

    $scope._init = function() {
        if (typeof $stateParams.id == "undefined") {
            $scope.data.header = "Nowy system api";
            var promise = systemApiService.create();
        } else {
            var promise = $stateParams.action == "view" ? systemApiService.show($stateParams.id) : systemApiService.edit($stateParams.id);
        }
        promise.success(function(result) {
            if(result.code == 0){
              $rootScope.notification.showAfterRedirect('admin_systemapi_edit', {'action':'view','id':$stateParams.id}, 'error', result.msg);
            }else{
              $scope.api.password = result.password;
              $scope.data.notifications = result.notifications;
              if (typeof result.row != "undefined")
                  $scope.api = result.row;
              if (typeof result.editable != "undefined") {
                  $scope.data.header = result.editable ? "Edycja systemu api" : "System api";
                  $scope.data.editable = result.editable;
                  if ($scope.data.editable == 0)
                      _$editmode.turnOff();
              }
            }
        });
    };

    $scope._init();

    $scope.sendMethodChange = function() {
        if (typeof $scope.api.priority == "undefined")
            $scope.api.priority = [];

        if (typeof $scope.api.notification != "undefined" && typeof $scope.api.priority != "undefined" &&
            $scope.api.priority.length != $scope.api.notification.length) {
            $scope.api.priority = angular.copy($scope.api.notification);
        }
    };

    $scope.priorityChange = function(index) {
        for (var i = 0; i < $scope.api.priority.length; i++) {
            if (i != index && $scope.api.priority[index] == $scope.api.priority[i]) {
                var find = "";
                for (var j = 0; j < $scope.api.notification.length; j++) {
                    if ($scope.api.priority.indexOf($scope.api.notification[j]) == -1)
                        find = $scope.api.notification[j];
                }
                $scope.api.priority[i] = find;
            }
        }
    };

    $scope.generatePassword = function() {
        var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
        var pass = "";
        for (var x = 0; x < 10; x++) {
            var i = Math.floor(Math.random() * chars.length);
            pass += chars.charAt(i);
        }
        $scope.api.password = pass;
    }

    $scope.delete = function(){
      $scope.showLoader = true;

      var promise = systemApiService.delete([$scope.api.id]);
      promise.then(
          function(payload) {
              if (payload.data.code) {
                  $scope.showLoader = false;
                  $rootScope.notification.showAfterRedirect('admin_systemapi', {}, 'success', payload.data.msg);
              } else {
                  $scope.showLoader = false;
                  $rootScope.notification.show('error', payload.data.msg);
              }
          });
    };
});
